import { setValue} from "../utils/Form";

/**
 | Ce fichier gère les informations à sauvegarder et restaurer des cookies pour les formulaires du site
 | Si un formulaire à un attribut data-cookie="no-cookie" alors aucun cookie ne sera géré pour le formulaire.
 | Si le nom du
 | Si un input à l'attribut autocomplete="off" aucune cookie ne sera géré pour l'input.
 */

/**
 * Prefix des cookies pour les formulaires
 * @type {string}
 */
const cookiePrefix = 'pcs.forms.'

/**
 * Délai d'expiration des cookies en jours
 */
const expirationTimes = 365;

/**
 * Nom des formulaires pour lequel on ne gère pas les cookies (sauvegarde et restauration des valeurs)
 */
const ignoresForms = [
    'tjs_search_mobile',
    'tjs_search',
    'PAGE_RESULTAT'
]

/**
 * Nom des inputs pour lesquelles on ne sauvegarde pas les valeurs dans un cookie
 * Attention : les clés ici doivent être en minuscule, les clés des inputs seront convertis en lowercase pour les cookies
 * @type {string[]}
 */
const ignoresInputs = [
    'search',
    'langue',
    'codepub',
    /*'numpop',*/
    'np_idmailing',
    'idmailing',
    'sitecache',
    'btn_envoi',
    'serial',
    'form',
    'go',
    'numsoc',
    'code',
    'idcompte_internet',
    'formulaire_modifie',
    'envoyer',
    'idprop',
    'p',
    'ref',
    'begin',
    'vcode',
    'dbgin',
    'type',
    'check',
    'type',
    'wde',
    'wme',
    'questiondifferee',
    'questiondirecte',
    'besoin',
    'g-recaptcha-response',
    'pcsoft_captcha',
    '__filtered_pcs_data',
    '_token',
]

/**
 * Sauvegarde les cookies en fonction des inputs
 * @param HTMLElementForm   Element HTML du formulaire
 */
const saveInputsInCookie = function(HTMLElementForm)
{
    const formData = new FormData(HTMLElementForm); //Informations contenu dans le formulaire
    formData.forEach((value, key) => {

        //console.log(cookiePrefix + key.toLowerCase())
        if(!ignoresInputs.includes(key.toLowerCase()))
        {
            // Sauvegarde des informations dans des cookies (cookieprefix.nomduchamp => valeur du champ)
            //console.log('cookie key : ' + cookiePrefix + key.toLowerCase() + ' | cookie value : ' + value)
            Cookies.set(
                cookiePrefix + key.toLowerCase(),
                value,
                { expires: expirationTimes }
            )
        }
    })
}

/**
 * Restaure les informations du formulaire avec les données contenu dans les cookies si elles existent.
 * @param HTMLElementForm   Element HTML du formulaire
 */
const restoreFormDataWithCookie = function (HTMLElementForm)
{
    const formData = new FormData(HTMLElementForm); //Récupération du formulaire en objet Javascript
    formData.forEach((value, key) => {

        const field = document.querySelector('[name="'+key+'"]')
        const autocomplete = field.getAttribute('autocomplete');

        const cookieValue = Cookies.get(cookiePrefix + key.toLowerCase())
        //console.log('cookie key : ' + cookiePrefix + key.toLowerCase() + ' | cookie value : ' + cookieValue)

        // Si on ignore le champ car le nom de l'input est dnas le tableau ignoresInputs
        // ou que l'attribut de l'input à un autocomplete="off"
        if(ignoresInputs.includes(key.toLowerCase()) || autocomplete === "off")
        {
            //console.log("j'ignore la clé " + key)
            return false;
        }

        if(cookieValue !== null && cookieValue !== undefined)
        {
            // Restauration de la valeur dans le champ
            // En fonction du type node on exécute un traitement différent (attribut value pour les input, et option selected pour les select)
            setValue(field, cookieValue, key)
        }
    })
}

/**
 * Capture les soumission des formulaires pour l'enregistrement des cookies
 *
 * @param HTMLElementForm   Element HTML du formulaire
 */
const captureFormSubmit = function (HTMLElementForm)
{
    HTMLElementForm.addEventListener('submit', (event) => {

        //event.preventDefault(); //Stop la propagation du formulaire
        saveInputsInCookie(HTMLElementForm)
        //console.log(event)
        //event.submit(); //Soumission du formulaire
    })
//<input name="BTN_ENVOI" type="BUTTON" class="textemobile" id="BTN_ENVOI3" onClick="BTNVALIDECLI()" value="Valider" style="cursor: pointer; font-weight:bold;">
    // Si un bouton du nom BTN_ENVOI ou un input de type button est présent dans le formulaire, on capture l'envoi depuis le clique sur le bouton.
    const submitButton = HTMLElementForm.querySelector('input[name="BTN_ENVOI"]')
        || HTMLElementForm.querySelector('input[type="button"]')
        || HTMLElementForm.querySelector('input[type="BUTTON"]')

    //console.log(submitButton);
    // Si on trouve un bouton alors, on capture également l'événement au clique
    if(submitButton !== null)
    {
        submitButton.addEventListener('click', (e) => {
            //console.log(e);
            saveInputsInCookie(HTMLElementForm)
        })
    }
}

// Récupération des formulaires
const forms = document.querySelectorAll('form')

// Pour chaque formulaire
forms.forEach(HTMLElementForm => {

    const formName     = HTMLElementForm.getAttribute('name') //Nom du formulaire
    const activeCookie = HTMLElementForm.getAttribute('data-cookie') //Valeur de l'attribut data-cookie

    // On ne gère pas les cookies pour le formulaire si :
    // Il n'a pas d'attribut name
    // Le nom du formulaire (attribut name) existe dans le tableau ignoreForms
    // Si le formulaire à un attribute data-cookie avec la valeur false ou no-cookie
    if(formName === null || (ignoresForms.includes(formName)) || activeCookie === 'no-cookie' || activeCookie === false || activeCookie === 'false')
    {
        //console.log('pas de cookie pour le formulaire : ', formName)
        return false
    }

    restoreFormDataWithCookie(HTMLElementForm)
    captureFormSubmit(HTMLElementForm)
})
